import React from 'react';
import PropTypes from 'prop-types';

import './BankAssociableText.scss';
import If from '../If/If';

const BankAssociableText = ({ containerClass, showText }) => {
  return (
    <If test={showText}>
      <div
        className={`bank-associable-text-note ${
          containerClass ? `bank-associable-text-${containerClass}` : ''
        }`}
      >
        Note:{' '}
        <span>
          Submitting this trade will link this specific account with your chosen
          bank for all future transactions. You can always edit this in your
          account settings.
        </span>
      </div>
    </If>
  );
};

BankAssociableText.defaultProps = {
  showText: false,
};

BankAssociableText.propTypes = {
  containerClass: PropTypes.string,
  showText: PropTypes.bool.isRequired,
};

export default BankAssociableText;
